import { OrderRouteItem, schOrderRouteItem } from '@aloft/toolkit-shared';
import { Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Typography } from '@aloft/toolkit-sui';

import { NavLink } from 'react-router-dom';

import { selectDeviceWidth } from '../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { menuListProps, menuProps } from '../consts.ts';
import { HeaderDesktopSubNav } from './HeaderDesktopSubNav.tsx';
import { HeaderMobileSubNav } from './HeaderMobileSubNav.tsx';
import { HeaderNavItem } from './HeaderNavItem.tsx';
import { craftsmanUIHeaderNavItems } from './constants.ts';
import { NavItemType, SubNavItemType, hasSubnav } from './types.ts';
import { useCurrentNavItem } from './useCurrentNavItem.ts';

const getRoute = (item: NavItemType) =>
  hasSubnav(item) ? `${item.route}/${(item.subnav[0] as SubNavItemType).route}` : item.route;

export const HeaderNav = () => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const headerNavItems = craftsmanUIHeaderNavItems;

  const currentNavItem = headerNavItems[useCurrentNavItem() ?? 'paired-cost'];

  const orderRouteItems = schOrderRouteItem.options;

  return (
    <Flex flexDirection="column" position="relative" alignSelf="center">
      {deviceWidth === 'phone' ? (
        <>
          <div className="main-header-nav-mobile">
            <Menu {...menuProps}>
              <MenuButton>
                <Flex gap=".25rem" alignItems="center" marginTop=".375rem">
                  <Typography variant="h4">{currentNavItem.label}</Typography>
                  <Icon icon="arrow-down-s" size="lg" color="textPrimary" />
                </Flex>
              </MenuButton>
              <MenuList {...menuListProps}>
                {orderRouteItems.map((itemName: OrderRouteItem) => {
                  const item = headerNavItems[itemName];

                  return (
                    <NavLink key={`header-nav-${item.route}`} to={getRoute(item)}>
                      <MenuItem>
                        <Typography variant="body1">{item.label}</Typography>
                      </MenuItem>
                    </NavLink>
                  );
                })}
              </MenuList>
            </Menu>
          </div>
          <HeaderMobileSubNav />
        </>
      ) : (
        <>
          <ul className="main-header-nav">
            {orderRouteItems.map((itemName: OrderRouteItem) => {
              const item = headerNavItems[itemName];
              return <HeaderNavItem key={item.route} item={item} to={getRoute(item)} />;
            })}
          </ul>
          <HeaderDesktopSubNav />
        </>
      )}
    </Flex>
  );
};
